module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/toolbar/pic-quick-7d776b.svg";